import styled from 'styled-components'
import { t } from 'ttag'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { WHITE } from '../../colors'

const ProgressWrapper = styled.div`
  width: 100%;
  position: relative;
  height: 15px;
`
const TaskProgressGraph = styled.div`
  color: ${WHITE};
`
const ProgressGraphWrapper = styled.div`
  width: 100%;
  position: relative;
`
const ProgressBarRect = styled.div`
  width: 100%;
  border: 1px solid #ccc;
  border-top: none;
  height: 14px;
  position: absolute;
  top: 0;
  left: 0;
`
const ProgressBarRectBg = styled(ProgressBarRect)`
  background-color: #fbe0cc;
  width: 100%;
`
const ProgressBarRectSecondary = styled(ProgressBarRect)`
  background-color: #000;
  opacity: 0.1;
  transition: all 0.2s ease-in-out;
  width: ${({ pct2, incomplete }) =>
    !isNaN(pct2) && pct2 > 0 && incomplete ? `${Math.min(100, pct2)}%` : 'initial'};
  display: ${({ pct2, incomplete }) =>
    !isNaN(pct2) && pct2 > 0 && incomplete ? 'initial' : 'none'};
`
const ProgressBarRectCompleted = styled(ProgressBarRect)`
  background-color: #b1cd52;
  min-width: 14px;
  transition: all 0.2s ease-in-out;
  width: ${({ pct }) => (!isNaN(pct) && pct > 0 ? `${Math.min(100, pct)}%` : 'initial')};
  display: ${({ pct }) => (!isNaN(pct) && pct > 0 ? 'initial' : 'none')};
`
const SubTextContainer = styled.div`
  margin: 10px 0;
  width: 100%;
`
const TaskProgressBar = ({ pct, subText, incomplete, onClick, pct2 }) => {
  const [childId] = useState(`stcontainer-${Math.round(10000000000 * Math.random())}`)

  return (
    <>
      <ProgressWrapper className="progress-task-bar">
        <TaskProgressGraph onClick={onClick} role="progressbar" aria-labelledby={childId}>
          <ProgressGraphWrapper>
            <ProgressBarRectBg aria-hidden={true} />
            <ProgressBarRectSecondary
              pct2={pct2}
              incomplete={incomplete}
              aria-hidden={true}
            />
            <ProgressBarRectCompleted pct={pct} aria-label={t`${pct} percent complete`} />
          </ProgressGraphWrapper>
        </TaskProgressGraph>
      </ProgressWrapper>
      {subText && <SubTextContainer id={childId}>{subText}</SubTextContainer>}
    </>
  )
}

TaskProgressBar.propTypes = {
  pct: PropTypes.number.isRequired,
  subText: PropTypes.string.isRequired,
  incomplete: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  pct2: PropTypes.number
}

export { TaskProgressBar }
